import React from 'react';
import { getStatusIcon } from 'utils/commonUtils';
import { OutlinedButton, StatusIcon } from 'components/Ui/styled';

const OutlinedButtonComponent = (props) => {
  const { handleClick, selectedItem, item, id, primary } = props;

  return (
    <OutlinedButton
      variant="outlined"
      onClick={() => handleClick(item)}
      aria-pressed={selectedItem === id ? 'true' : 'false'}
      disabled={primary}
    >
      <StatusIcon>{getStatusIcon(item)}</StatusIcon>
      <span>
        {item.startTimeFmt} - {item.endTimeFmt}
      </span>
    </OutlinedButton>
  );
};

export default OutlinedButtonComponent;
